import { FC } from "react";
import { Outlet } from "react-router-dom";
import Loader from "../components/UI/loader/Loader";
import { useAppSelector } from "../hooks/ReduxHooks";
import NotFoundPage from "../components/pages/not-found/NotFoundPage";
import { operatorRole } from "../redux/types/OperatorTypes";

const DevRoutes: FC = () => {
  const { operator, authLoading, isAuthChecked } = useAppSelector(
    (state) => state.operator,
  );

  if (authLoading || !isAuthChecked) {
    return <Loader />;
  }

  const isDev = operator?.role === operatorRole.DEV;

  if (isDev) {
    return <Outlet />;
  }

  return <NotFoundPage />;
};

export default DevRoutes;
